import React from 'react'
import PropTypes from 'prop-types'
import { getMapValue, useWillPipe } from '@morningtrain/react-helpers'
import {
  useModel,
  useModelKey,
  useModelKeyName,
  useOperations,
  useResource
} from '../hooks'
import set from 'lodash/set'

function ExecuteOperationForModelOnPipe (props) {
  const resource = useResource()
  const operations = useOperations()

  const model = useModel()
  const modelKey = useModelKey()
  const modelKeyName = useModelKeyName()

  const namespace = props.namespace || ((resource && resource.namespace) ? resource.namespace : null)
  const resourceName = props.resourceName || ((resource && resource.slug) ? resource.slug : null)
  const { operationName } = props

  const baseOperation = operations.get(namespace, resourceName, operationName)
  const operation = operations.get(namespace, resourceName, operationName, { [baseOperation.parameterKey]: modelKey, ...props.operationContext })

  useWillPipe((payload) => {
    return new Promise((resolve, reject) => {
      if (!operation) {
        reject('Attempted to pipe an operation execute, but the requested operation was falsy')
      }

      const dataResolver = (typeof props.data === 'function') ? props.data(payload) : (props.data || payload.data)

      Promise.resolve(dataResolver)
        .then(data => {
          operation.execute({ [operation.parameterKey]: modelKey || getMapValue(model, modelKeyName) }, data || {})
            .then((rsp) => {
              set(payload, 'responses.' + (props.payloadResponseKey || operationName), rsp)

              resolve(payload)
            })
            .catch((err) => {
              reject(err)
            })
        })
        .catch(err => {
          reject(err)
        })
    })
  })

  return null
}

ExecuteOperationForModelOnPipe.defaultProps = {
  namespace: null,
  resourceName: null,
  operationName: null,
  operationContext: {},
  payloadResponseKey: null,
  data: {}
}

ExecuteOperationForModelOnPipe.propTypes = {
  namespace: PropTypes.string,
  resourceName: PropTypes.string,
  operationName: PropTypes.string.isRequired,
  operationContext: PropTypes.object,
  payloadResponseKey: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
}

export default ExecuteOperationForModelOnPipe
